export default "__VITE_ASSET__8383aed3__"